import React, { Component } from 'react';

class Download extends Component {
  render() {
    return (
      <div className="container-fluid">
  <div className="row">
    <div className="col">
      <h1 style={{backgroundColor: 'gray', padding: 70}}>Hello. You are in "DOWNLOAD" page!</h1>
    </div>
  </div>
</div>

    );
  }
}

export default Download;